/**
 * 验证用户名: 6-32位数字、英文字母、符号(_, @, -)
 * @type {RegExp}
 */
const REG_USER_NAME = /^[a-zA-Z0-9_@-]{5,31}$/

/**
 * 用户密码: 以字母开头，长度在6~18之间，只能包含字母、数字和下划线
 * @type {RegExp}
 */
const REG_PASSWORD = /^[a-zA-Z]\w{5,31}$/

/**
 * 包含汉字字母
 * @type {RegExp}
 */
const REG_HAN_LETTER = /^[\u4e00-\u9fa5_a-zA-Z]+$/

/**
 * 以1开始的11位数字
 * @type {RegExp}
 */
const REG_PHONE_NO = /^1\d{10}$/

/**
 * 手机验证码
 * @type {RegExp}
 */
const REG_PHONE_CODE = /^1\d{5}$/

// eslint-disable-next-line standard/object-curly-even-spacing
export { REG_USER_NAME, REG_PASSWORD, REG_HAN_LETTER, REG_PHONE_NO, REG_PHONE_CODE}



// WEBPACK FOOTER //
// ./src/lib/regExpUtil.js